import React, { Component } from 'react';
import SystemTranslationLabelProgressService from '../services/SystemTranslationLabelProgressService';
import { observer } from 'mobx-react';
import SystemTranslationProgress from './SystemTranslationProgress';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';

class SystemTranslationLabelProgressContainer extends Component {
  systemTranslationLabelProgressService = new SystemTranslationLabelProgressService();

  componentDidMount() {
    this.systemTranslationLabelProgressService.init(this.props.locale);
  }

  render() {
    return (
      <SystemTranslationProgress
        title="Labels"
        percentage={this.systemTranslationLabelProgressService.progress.percentage}
        total={this.systemTranslationLabelProgressService.progress.translated}
        fetching={this.systemTranslationLabelProgressService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/localization',
            query: { locale: this.props.locale.key },
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

SystemTranslationLabelProgressContainer.propTypes = {
  locale: PropTypes.shape({
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(SystemTranslationLabelProgressContainer);
